import React, { Component, Fragment } from 'react';

import A5Img from '../../assets/svg/a5-logo.svg';
import facebook from '../../assets/img/icon-face.png';
import instagram from '../../assets/img/icon-instagram.png';
import userLogin from '../../assets/img/userlogin.png';
import scrollTo from '../../helpers/scroll';
import iconMenu from '../../assets/img/menu-icon.png';
import SideMenu from '../../components/SideMenu';
import './HeaderWebBook.css';

export default class HeaderWebBook extends Component {

    constructor(props) {
        super(props);
        this.state = {
            header: React.createRef(),
            headerFixed: false,
            isOpen: false,
        }
        this.handleScroll = this.handleScroll.bind(this);
        this.handleToogleButton = this.handleToogleButton.bind(this);
        this.handleStateModal = this.handleStateModal.bind(this);
    }
    handleClickScrollTo(id) {
        scrollTo(id);
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    handleScroll() {
        let top = window.pageYOffset || document.documentElement.scrollTop;
        const { header } = this.state;
        const { current: element } = header;
        let flag = false;
        if (top > element.offsetHeight) {
            flag = true;
        }
        else {
            flag = false;
        }
        this.setState({ headerFixed: flag });
    }
    handleToogleButton() {
        const { isOpen } = this.state;
        this.setState({ isOpen: !isOpen });
    }

    async handleStateModal(state){
        this.setState({isOpen: state.isOpen});
    }

    render() {
        const { header, headerFixed, isOpen } = this.state;
        console.log(headerFixed);
        return (
            <Fragment>
                 <SideMenu
                    isOpen={isOpen}
                    stateModal={this.handleStateModal}
                />
                <header ref={header} className={`headerwebbook ${headerFixed ? 'headerwebbook--fixed' : ''} ${isOpen ? 'headerwebook--fixed--none': ''}`}>
                    <div className="headerwebbook__content">
                        <div className="headerwebbook__content__logo">
                            <div className="headerwebbook__content__logo__sociais">
                                <a target="blank" href="https://facebook.com/a5editora">
                                    <img className="headerwebbook__content__logo__sociais__image" src={facebook} alt="" />
                                </a>
                                <a target="blank" href="https://instagram.com/a5editora?utm_source=ig_profile_share&igshid=uv77n98kxjaf">
                                    <img className="headerwebbook__content__logo__sociais__image" src={instagram} alt="" />
                                </a>
                            </div>
                            <div className="headerwebbook__content__logo__logo">
                                <img src={A5Img} alt="" />
                            </div>
                            <div className="headerwebbook__content__logo__acess">

                                <div className="headerwebbook__content__logo__acess__buttons">
                                    <button className="headerwebbook__content__logo__acess__buttons_button" >Entrar</button>
                                    <button className="headerwebbook__content__logo__acess__buttons_button" >Cadastrar</button>
                                </div>
                                <img className="headerwebbook__content__logo__acess__userlogin" src={userLogin} alt="" />
                            </div>
                        </div>
                        <div className="headerwebbook__content__menu--responsive">
                            <button onClick={this.handleToogleButton} className="headerwebbook__content__menu--responsive__button" >
                                <img className="headerwebbook__content__menu--responsive__button__image" src={iconMenu} alt="icon-menu" />
                            </button>
                            <span className="headerwebbook__content__menu--responsive__title" >MENU</span>
                        </div>
                        <div className="headerwebbook__content__menu">
                            <ul className="headerwebbook__content__menu__list">
                                <li className="headerwebbook__content__menu__list__item" onClick={(e) => this.handleClickScrollTo('book')} >O LIVRO</li>
                                <li className="headerwebbook__content__menu__list__item" onClick={(e) => this.handleClickScrollTo('apresentation')} >APRESENTAÇÃO</li>
                                <li className="headerwebbook__content__menu__list__item" onClick={(e) => this.handleClickScrollTo('author')} >O AUTOR</li>
                                <li className="headerwebbook__content__menu__list__item" onClick={(e) => this.handleClickScrollTo('weblivro')} >O QUE É WEBLIVRO? </li>
                                <li className="headerwebbook__content__menu__list__item" onClick={(e) => this.handleClickScrollTo('messageautor')} >FALE COM O AUTOR</li>
                            </ul>
                        </div>
                    </div>
                </header>
               
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/HeaderWebBook/HeaderWebBook.js